'use client';

import { useLayoutEffect } from 'react';

import { getViewSearchResultsType, useAnalyticsContext } from '@libs/analytics';

import { dataLayerPush } from '@/shared/analytics';

export const useViewSearchResults = () => {
    const { getSearchStats, setSearchStats } = useAnalyticsContext();

    const { searchTerm, searchType, searchResults, isSuggestedProduct } = getSearchStats();
    const countResults = searchResults ?? 1;

    useLayoutEffect(() => {
        if (isSuggestedProduct) {
            dataLayerPush({
                event: 'view_search_results',
                results: countResults,
                search_term: searchTerm,
                search_type: getViewSearchResultsType(countResults, searchType),
            });
            setSearchStats({ searchTerm });
        }
    }, [searchTerm, searchResults, searchType, isSuggestedProduct]);
};
